import { showError } from "../utils/errorHandler";
import {
  arrayContainsDuplicates,
  arrayContainsOnlyIntegers,
  arrayContainsOnlyPositiveNumbers
} from "./utils";

export const betSize = (size: number, origin?: string): boolean => {
  if (!(Number.isInteger(size) && size > 0)) {
    showError("Bet size has to be a positive integer", origin);
    return false;
  }

  return true;
};

export const betLevel = (level: number, origin?: string): boolean => {
  if (!(Number.isInteger(level) && level > 0)) {
    showError("Bet level has to be a positive integer", origin);
    return false;
  }

  return true;
};

export const betLevels = (values: number[], origin?: string): boolean => {
  if (!Array.isArray(values)) {
    showError("Bet levels has to be an array", origin);
    return false;
  } else if (values.length < 1) {
    showError("Bet levels must contain at least one choice", origin);
    return false;
  } else if (!arrayContainsOnlyIntegers(values)) {
    showError("Bet levels array can only contain integers", origin);
    return false;
  } else if (!arrayContainsOnlyPositiveNumbers(values)) {
    showError("Bet levels array can only contain positive integers", origin);
    return false;
  } else if (arrayContainsDuplicates<number>(values)) {
    showError("Bet levels array cannot contain duplicate values", origin);
    return false;
  }

  return true;
};

export const betDenominations = (
  values: number[],
  origin?: string
): boolean => {
  if (!Array.isArray(values)) {
    showError("Denominations has to be an array", origin);
    return false;
  } else if (values.length < 1) {
    showError("Denominations must contain at least one choice", origin);
    return false;
  } else if (!arrayContainsOnlyIntegers(values)) {
    showError("Denominations array can only contain integers", origin);
    return false;
  } else if (!arrayContainsOnlyPositiveNumbers(values)) {
    showError("Denominations array can only contain positive integers", origin);
    return false;
  } else if (arrayContainsDuplicates<number>(values)) {
    showError("Denominations array cannot contain duplicate values", origin);
    return false;
  }

  return true;
};

export const betDenomination = (
  denomination: number,
  denominations: number[],
  origin?: string
): boolean => {
  if (!Number.isInteger(denomination)) {
    showError("Denomination has to be an integer", origin);
    return false;
  } else if (!denominations.includes(denomination)) {
    showError("Denomination has to be a valid denomination value", origin);
    return false;
  }

  return true;
};
